import React, { Component } from 'react'
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Select from 'react-select';
import { connect } from 'react-redux'
import { api } from "../../../../../../api/index"
import TimePickerDialog from "material-ui/TimePicker/TimePickerDialog";
import DatePickerDialog from "material-ui/DatePicker/DatePickerDialog";
import {config} from "../../../../../../config";
import axios from "axios/index";
import {loadImages, resetImages} from "../../../../../../api/images";
import {getTopics} from "../../../../../../api/topics";
import { getCategories } from '../../../../../../api/categories';


class PromotionGeneralActieblockComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoadingPosts: false,
		};

		this.handlePositionFieldState = this.handlePositionFieldState.bind(this);
		this.handleTopicChange = this.handleTopicChange.bind( this );
		this.handleCategoryChange = this.handleCategoryChange.bind( this );
		// this.getCategories = this.getCategories.bind( this );
	}

	componentDidMount() {
		resetImages().then( () => {
			loadImages([
				{
					width: 214,
					height: 156,
				}
			]);
		});

		getTopics();
		getCategories();
	}

	setSearchQuery(value) {
		api.promotions.handleState('postIds', value);
	}

	getPosts(input, callback) {
		let cancel;

		if ( input.length < 4 ) {
			return;
		}

		return axios.get(config.postSearch.url + '?s=' + input, )
			.then( ( response ) => {
				return new Promise((resolve, reject) => {
					let i = 0;
					let options = [];

					if (response.data.length > 0) {
						response.data.map((item) => {

							let obj = {
								ID: item.ID,
								post_title: item.post_title
							};

							options.push(obj);

							if (options.length === response.data.length) {
								resolve(options);
							}
						})
					} else {
						resolve(options);
					}


				}).then(options => {
					return {
						options: options
					};

				})
			})
	}

	handlePositionFieldState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handlePositionFieldState( name, value, this.props.periodKey, this.props.variantKey );
	}

	renderCategories() {
		const { categories } = this.props;

		categories.data.sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);} );

		return categories.data.map( ( category, index ) =>
			<MenuItem key={index} value={category.key} primaryText={category.name.replace('&amp;', '&')} />
		)
	}

	renderTopics() {
		const { topics } = this.props;

		topics.data.sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);} );

		return topics.data.map( ( topic, index ) =>
			<MenuItem key={index} value={topic.key} primaryText={topic.name} />
		)
	}

	handleTopicChange(event, index, value) {
		api.promotions.handleState( 'topicIds', value);
	}

	handleCategoryChange(event, index, value) {
		api.promotions.handleState( 'categoryIds', value);
	}



	render() {
		return (
			<div className="grid-x grid-margin-y grid-margin-x">
				<div className="medium-4 cell">
					<label>
						Koppelen aan posts
						<Select.Async
							multi={true}
							valueKey="ID"
							labelKey="post_title"
							loadOptions={this.getPosts}
							value={this.props.promotion.postIds}
							onChange={this.setSearchQuery}
							isLoading={this.state.isLoadingPosts}
						/>
					</label>
				</div>
				<div className="medium-4 cell">
					<label>
						Koppelen aan topics
						<SelectField
							floatingLabelText="Topics"
							value={this.props.promotion.topicIds}
							fullWidth={true}
							onChange={this.handleTopicChange}
							multiple={true}
						>
							{this.renderTopics()}
						</SelectField>
					</label>
				</div>
				<div className="medium-4 cell">
					<label>
						Koppelen aan categorie&euml;n
						<SelectField
							floatingLabelText="Categorie&euml;n"
							value={this.props.promotion.categoryIds}
							fullWidth={true}
							onChange={this.handleCategoryChange}
							multiple={true}
						>
							{this.renderCategories()}
						</SelectField>
					</label>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion,
		topics: state.topics,
		categories: state.categories
	}
};

export default connect(mapStateToProps, {
	loadImages,
	resetImages,
	getTopics,
	getCategories
})(PromotionGeneralActieblockComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/general/actieblock.js